import { render, staticRenderFns } from "./PaymentTypeSelector.vue?vue&type=template&id=4cb641a7&"
import script from "./PaymentTypeSelector.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb641a7')) {
      api.createRecord('4cb641a7', component.options)
    } else {
      api.reload('4cb641a7', component.options)
    }
    module.hot.accept("./PaymentTypeSelector.vue?vue&type=template&id=4cb641a7&", function () {
      api.rerender('4cb641a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Rules/PaymentTypeSelector.vue"
export default component.exports